import { createRouter, createWebHistory } from 'vue-router';
import i18n from '../i18n';
import auth from './middleware/auth';
import mobile from './middleware/mobile';

const routes = [
    {
        path: '/login',
        name: 'login-es',
        component: () => import('@/views/Login/Login.vue'),
        beforeEnter: [mobile],
    },
    {
        path: '/:locale/login',
        name: 'login',
        component: () => import('@/views/Login/Login.vue'),
        beforeEnter: [mobile],
    },
    {
        path: '/',
        component: () => import('@/layouts/MainLayout.vue'),
        children: [
            {
                path: '',
                name: 'home',
                beforeEnter: [auth, mobile],
                redirect: '/mi-cuenta',
            },
            {
                path: '/mi-cuenta/cambiar-plan',
                component: () => import('@/views/MiCuenta/ChangePlan/ChangePlan.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'cambiar-plan',
                        component: () => import('@/views/MiCuenta/ChangePlan/ChangePlanPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/mi-cuenta/sostenibilidad',
                component: () => import('@/views/MiCuenta/Sustainability/Index.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'sostenibilidad',
                        component: () => import('@/views/MiCuenta/Sustainability/SustainabilityView.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'estrategia-aquaservice',
                        name: 'estrategia-aquaservice',
                        component: () => import('@/views/MiCuenta/Sustainability/StrategyView.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/mi-cuenta/coffeeb',
                component: () => import('@/views/MiCuenta/CoffeeB/CoffeeBPanel.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'coffeeb',
                        component: () => import('@/views/MiCuenta/CoffeeB/CoffeeB.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/mi-cuenta',
                component: () => import('@/views/MiCuenta/MiCuenta.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'mi-cuenta',
                        component: () => import('@/views/MiCuenta/MiCuentaPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'mis-direcciones',
                        name: 'mis-direcciones',
                        component: () => import('@/views/MiCuenta/MisDirecciones/MisDireccionesPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'metodos-pago',
                        name: 'metodos-pago',
                        component: () => import('@/views/MiCuenta/MetodosPago/PaymentMethods.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'nueva-tarjeta',
                        name: 'nueva-tarjeta',
                        component: () => import('@/views/MiCuenta/MetodosPago/AddCard.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'datos-facturacion',
                        name: 'datos-facturacion',
                        component: () => import('@/views/MiCuenta/BillingInfo/BillingInfo.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/reparto-programado',
                name: 'reparto-programado',
                component: () => import('@/views/Repartos/RepartoProgramadoPanel.vue'),
                beforeEnter: [auth, mobile],
            },
            {
                path: '/reparto-urgente',
                name: 'reparto-urgente',
                component: () => import('@/views/Repartos/RepartoUrgentePanel.vue'),
                beforeEnter: [auth, mobile],
            },
            {
                path: '/facturas',
                component: () => import('@/views/Invoices/Invoices.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'facturas',
                        component: () => import('@/views/Invoices/InvoicesPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'pagar-ahora',
                        name: 'pagar-ahora',
                        component: () => import('@/views/Invoices/PayInvoicesNowPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/entregas',
                component: () => import('@/views/DeliveryHistory/DeliveryHistory.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'entregas',
                        component: () => import('@/views/DeliveryHistory/DeliveryHistoryPanel.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/aquamigo',
                component: () => import('@/views/Aquamigo/Aquamigo.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'aquamigo',
                        component: () => import('@/views/Aquamigo/AquamigoForm.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'invitaciones',
                        name: 'aquamigo-invitaciones',
                        component: () => import('@/views/Aquamigo/AquamigoInvitations/AquamigoInvitations.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'invitacion/:id',
                        name: 'aquamigo-invitacion-id',
                        component: () => import('@/views/Aquamigo/AquamigoInvitations/AquamigoInvitation/AquamigoInvitation.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ],
            },
            {
                path: '/mi-cuenta/cambiar-unidades',
                name: 'cambiar-unidades',
                component: () => import('@/views/MiCuenta/ChangeUnits/ChangeUnits.vue'),
                meta: {
                    middleware: [auth, mobile],
                },
            },
            {
                path: '/atencion-cliente',
                component: () => import('@/views/Atencion/AtencionIndex.vue'),
                beforeEnter: [auth, mobile],
                children: [
                    {
                        path: '',
                        name: 'atencion-cliente',
                        component: () => import('@/views/Atencion/Atencion.vue'),
                        beforeEnter: [auth, mobile],
                    },
                    {
                        path: 'incidence',
                        name: 'incidence',
                        component: () => import('@/views/Atencion/Incidence/Incidence.vue'),
                        beforeEnter: [auth, mobile],
                    },
                ]
            },
            {
                path: '/administrar-perfiles',
                name: 'administrar-perfiles',
                component: () => import('@/views/Profiles/ManageProfiles.vue'),
                beforeEnter: [auth, mobile],
            },
        ],
    },
    {
        path: '/mobile',
        name: 'mobile',
        component: () => import('@/views/AppMobile.vue'),
    },
    {
        path: '/external-coffeeb',
        name: 'external-coffeeb',
        component: () => import('@/views/MiCuenta/CoffeeB/CoffeeB.vue'),
    },
    {
        path: '/external-coffeeb/:bannerType',
        name: 'external-coffeeb-ka-ma',
        component: () => import('@/views/MiCuenta/CoffeeB/CoffeeB.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/Error404.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0, left: 0 };
    },
});

const isAuthenticated = () => {
    return !!localStorage.getItem('token') && !!localStorage.getItem('pin');
};

router.beforeEach(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('token') && urlParams.has('pin')) {
        localStorage.clear();
        for (const [key, value] of urlParams.entries()) {
            localStorage.setItem(key, value);
        }
        window.location.href = '/';
    }
});

router.beforeEach((to, from, next) => {
    const { locale } = to.params;
    const allowedLocales = ['es', 'en'];
    let selectedLocale: 'es' | 'en' = 'es';
    if (typeof locale === 'string' && allowedLocales.includes(locale)) {
        selectedLocale = locale as 'es' | 'en';
        i18n.global.locale.value = selectedLocale;
    } else if (!locale) {
        i18n.global.locale.value = 'es';
    } else if (typeof i18n.global.fallbackLocale === 'string' && allowedLocales.includes(i18n.global.fallbackLocale)) {
        i18n.global.locale.value = i18n.global.fallbackLocale as 'es' | 'en';
    } else {
        i18n.global.locale.value = 'es';
    }

    if (to.name !== 'login' && !isAuthenticated()) {
        next({ name: 'login', params: { locale: i18n.global.locale.value } });
    } else {
        next();
    }
});

router.onError((error) => {
    if (error.message.includes('Failed to fetch dynamically imported module')) {
        window.location.reload();
    }
});

export default router;
